<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn class="ml-2" @click.stop="dialog = true" v-bind="attrs" v-on="on" color="secondary">
				<v-icon class="mr-2">mdi-cog-outline</v-icon>
				<slot name="btn-text"> 設定する </slot>
			</v-btn>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"> 帳票設定 </v-app-bar-title>
				<v-spacer />
				<v-btn v-if="$vuetify.breakpoint.xs" @click="dialog = false" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-row no-gutters class="mt-2 px-2" justify="end">
				<TemplateDeleteDialog
					ref="deleteDialog"
					:confirm="true"
					:deleteMethod="deleteExcelTemplate"
				>
					<template slot:btn-text> 帳票を削除する </template>
				</TemplateDeleteDialog>
			</v-row>
			<v-form ref="form" class="pa-2" v-model="valid">
				<ExcelTemplateForm
					:excel_template.sync="excelTemplate"
					:modelNames="modelNames"
					:departments="departments"
					:showFileInput="false"
					:disabledBaseModelSelect="true"
				/>
			</v-form>
			<v-card-actions>
				<v-row class="ma-0 pa-0" justify="center">
					<v-col sm="4" />
					<v-col sm="4">
						<v-row justify="center">
							<v-btn class="ma-1" :disabled="!valid"  @click="updateExcelTemplate()" color="secondary">
								保存する
							</v-btn>
						</v-row>
					</v-col>
					<v-col sm="4">
						<v-row align="center">
							<v-spacer></v-spacer>
							<v-btn
								v-if="!$vuetify.breakpoint.xs"
								color="grey darken-1"
								text
								@click="dialog = false"
							>
								閉じる
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import ExcelTemplateForm from "./ExcelTemplateForm.vue"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"

export default {
	props: {
		excel_template: {
			type: Object,
			required: true,
			default: {
				name: {
					type: String,
					required: true,
				},
				base_model: {
					type: String,
					required: true,
				},
				exclusive_flag: {
					type: Boolean,
					required: true,
				},
				department_id: {
					type: Number,
					required: true,
				},
			},
		},
		modelNames: {
			type: Array,
			required: true,
			default: () => [
				{
					id: {
						type: Number,
						required: true,
					},
					name: {
						type: String,
						required: true,
					},
				},
			],
		},
		departments: {
			type: Array,
			required: true,
			default: () => [
				{
					id: {
						type: Number,
						required: true,
					},
					name: {
						type: String,
						required: true,
					},
				},
			],
		},
		showFileInput: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabledBaseModelSelect: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	components: {
		ExcelTemplateForm,
		TemplateDeleteDialog,
	},
	data() {
		return {
			id: this.$route.params.id,
			dialog: false,
			valid: false,
			excelTemplate: {
				name: null,
				base_model: null,
				exclusive_flag: null,
				department_id: null,
			},
		}
	},
	methods: {
		updateExcelTemplate() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/excel_templates/${this.id}/`
			axios
				.patch(url, { excel_template: {
					name: this.excelTemplate.name,
					exclusive_flag: this.excelTemplate.exclusive_flag,
					department_id: this.excelTemplate.department_id,
				} }, { headers })
				.then((res) => {
					this.excelTemplate = res.data.excel_template
					this.$emit("update:excel_template", this.excelTemplate)
					this.$store.dispatch("setFlash", {
						text: "設定を保存しました。",
						type: "notice",
					})
					this.dialog = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		deleteExcelTemplate() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/excel_templates/${this.id}/`
			axios
				.delete(url, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "帳票を削除しました。",
						type: "notice",
					})
					this.$router.push({ name: "excel_template_index" })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		excel_template(newVal, _) {
			this.excelTemplate = newVal
		},
		deep: true,
	},
}
</script>